import React, { useState, useEffect } from "react";
import { FaHeart, FaHandHoldingHeart, FaBrain, FaUsers, FaWhatsapp, FaInstagram, FaClock, FaDollarSign, FaLaptop, FaCalendarAlt, FaLeaf, FaEye, FaBars, FaTimes  } from "react-icons/fa";

const MaternalTherapyLanding = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const settings = {
    dots: true,
    testimonials_wait_seconds: 10,
    tmi_phrase: "Transforma tu forma de criar, cultiva vínculos sólidos, equilibra tu vida y potencia el desarrollo emocional de tus hijos.",
    site_title: "Alma de niño",
    site_description: "Terapia Materno Infantil",
  };

  // Added auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.list.length);
    }, settings.testimonials_wait_seconds * 1000);

    return () => clearInterval(timer);
  }, []);

  const whatsappNumber = "+5492215084595";
  const whatsappMessage = "Hola, me gustaría agendar una consulta. Mi nombre es ";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const hero_section = {
    title: settings.site_title,
    subtitle: settings.site_description,
    cta_text: "Agendar entrevista",
    cta_link: whatsappLink,
    image: "/madre.jpg"
    // image: "/hero.png"
  }

  const about = {
    title: "Sobre mí",
    image: "/about-me.jpg",
    alt: "Melina González Paulos",
    text: "¿Quién soy? Mi nombre es Melina González Paulos soy mamá de 3 niños y especialista en desarrollo infantil y en vínculo materno infantil, mi formación es de Lic. en atención temprana al desarrollo infantil, profesora en discapacidad intelectual y facilitadora del método paternidad efectiva. Me apasiona el mar y surfar, creo que la maternidad y la vida es un poco eso, saber leer la ola que llega y poder pararnos sobre ella de la mejor manera, con disfrute, seguridad y alegría. Aunque seguramente muchas veces terminemos en el agua con cada ola aprender algo nuevo y único es para mi el desafío mas hermoso."
  };

  const services = {
    title: "Qué podemos hacer juntos",
    subtitle: "¡Hola! Soy Meli, especialista en acompañar a madres y padres en procesos de crianza efectiva, no perfecta. Mi enfoque se centra en proporcionar apoyo práctico y emocional para que puedas criar a tus hijos de la mejor manera posible, reconociendo que la perfección no es el objetivo, sino el crecimiento y el bienestar de toda la familia. En mi experiencia, he observado que la crianza puede presentar una variedad de desafíos. Algunos de los problemas más comunes que abordamos juntos incluyen",
    list: [
    {
      icon: <FaHeart />,
      title: "Establecimiento de límites saludables",
      description: "Encontrar el equilibrio entre ser firme y comprensivo puede ser complicado. Te ayudo a implementar estrategias que promuevan el respeto mutuo y el desarrollo de la autodisciplina en tus hijos"
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Manejo del comportamiento", 
      description: "Desde las rabietas y el comportamiento desafiante hasta la gestión de las emociones, te proporciono herramientas para entender y abordar las diferentes formas en que los niños expresan sus necesidades y frustraciones."
    },
    {
      icon: <FaBrain />,
      title: "Comunicación Familiar Efectiva",
      description: "La forma en que te comunicas con tus hijos impacta directamente en la relación familiar. Te brindo apoyo para desarrollar habilidades de comunicación claras y empáticas que fortalezcan el vínculo con tus hijos y mejoren la dinámica familiar."
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Equilibrio entre la vida familiar y personal", 
      description: "La crianza puede ser abrumadora y encontrar tiempo para uno mismo y para la pareja es esencial. Juntos, buscamos estrategias para equilibrar las responsabilidades familiares y el autocuidado."
    },
    {
      icon: <FaUsers />,
      title: "Desarrollo emocional y social",
      description: "Fomentar la autoestima, la empatía y las habilidades sociales en tus hijos es crucial para su desarrollo. Te ofrezco apoyo para crear un entorno que promueva un crecimiento emocional saludable. Partiendo siempre desde tus habilidades, necesidades y heridas a sanar para transformarte primero a vos."
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Gestión del estrés y las emociones para padres",
      description: "La crianza puede ser un desafío emocional, especialmente cuando lidias con estrés o emociones intensas. Te ayudo a identificar y manejar tus propias emociones para que puedas afrontar los desafíos diarios con mayor serenidad y construir un ambiente emocionalmente seguro para tus hijos."
    }
  ]};

  const testimonials = {
    title: "Historias de transformación",
    list: [
    {
      name: "Laura, madre de dos hijos",
      text: "Desde que comencé a trabajar con Melina, mi forma de abordar la crianza de mis hijos cambió por completo. Me ayudó a entender cómo establecer límites saludables sin sentirme culpable, y cómo ser firme pero comprensiva. Gracias a su enfoque práctico y empático, logré conectar mejor con mis hijos y gestionar sus emociones de manera más efectiva. ¡Hoy mi familia disfruta mucho más de la crianza!",
      image: "/tm1.png"
    },
    {
      name: "Sofía, mamá de una niña",
      text: "Trabajar con Meli ha sido una experiencia transformadora. No solo me brindó herramientas para gestionar los comportamientos desafiantes de mi hija, sino que también me ayudó a cuidar de mí misma como madre. Me enseñó a equilibrar mi vida personal con la crianza, algo que pensaba que nunca lograría. Ahora me siento más segura y confiada en mi rol de mamá.",
      image: "/tm2.png"
    },
    {
      name: "Andrea, madre de tres hijos",
      text: "Nunca imaginé que hablar con alguien sobre mi forma de criar a mis hijos me ayudaría tanto. Las sesiones con Melina no solo me enseñaron a mejorar la comunicación con mis hijos, sino que también me ayudaron a sanar heridas propias para poder ser una mejor madre. Gracias a su acompañamiento, ahora veo la crianza como un proceso de crecimiento continuo, y no como un desafío constante.",
      image: "/tm3.png"
    }
  ]};

  const footer = {
    phone: "(221) 508-4595",
    email: "almadenino.crianza@gmail.com",
    social: [
    {
      icon: <FaInstagram />,
      link: "https://www.instagram.com/almadenino.crianza/"
    },
  ]};


  const plans = [
    {
      id: "individual",
      title: "Sesión Individual",
      quote: "Si buscas resultados diferentes, no hagas siempre lo mismo.",
      author: "Albert Einstein",
      details: [
        { icon: <FaClock />, label: "Duración", value: "1 hora y media" },
        { icon: <FaLaptop />, label: "Formato online", value: "Desde tu lugar seguro, cómodo y acompañado de algo para anotar y un buen café (o mate en mi caso)." },
        { icon: <FaDollarSign />, label: "Importe", value: "30 USD por sesión" },
        { icon: <FaCalendarAlt />, label: "Horarios", value: "Lunes a viernes, 8am a 5pm (horario Argentina)" },
      ],
      price: 30,
      priceDescription: "por sesión",
      ctaText: "Contratar Ahora",
      ctaLink: `https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hola, me gustaría contratar el plan individual. Mi nombre es')}`,
    },
    {
      id: "complete",
      title: "Método Completo",
      quote: "Quien mira hacia afuera sueña, quien mira hacia adentro se transforma.",
      author: "Carl Jung",
      details: [
        { icon: <FaClock />, label: "Duración", value: "12 sesiones de 1 hora y media cada una + tareas individuales" },
        { icon: <FaDollarSign />, label: "Importe", value: "360 USD por el programa completo" },
        { icon: <FaCalendarAlt />, label: "Horarios", value: "Lunes a viernes, 8am a 7pm (horario Argentina)" },
      ],
      price: 360,
      priceDescription: "programa completo",
      ctaText: "Contratar Ahora",
      ctaLink: `https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hola, me gustaría contratar el plan completo. Mi nombre es')}`,
    },
  ];

  // Lista de herramientas parametrizada
const tools = [
    {
      icon: <FaUsers />,
      description: "Terapia familiar vínculo diada materno-infantil, paterno-infantil. Trabajamos desde los adultos.",
    },
    {
      icon: <FaHandHoldingHeart />,
      description: "Método paternidad y maternidad efectiva (niños de ahora).",
    },
    {
      icon: <FaBrain />,
      description: "Neurociencia.",
    },
    {
      icon: <FaLeaf />,
      description: "Respiración consciente.",
    },
    {
      icon: <FaEye />,
      description: "Visualizaciones guiadas.",
    },
  ];

  return (
    <div className="font-sans">
      {/* Hero Section */}
      <div className="relative h-screen">
        {/* Sticky Header */}
        <div
          className={`fixed left-0 w-full z-50 bg-[#206760] text-white transition-all ${
            isMenuOpen || scrollPosition > 0 ? "h-16 shadow-lg top-0" : "h-0 top-8"
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-full">
            <a href="/">
            <img
              src="/ico_alma_nino_color.png"
              alt="Alma de niño logo"
              className={`transition-all ${
                isMenuOpen || scrollPosition > 0 ? "w-12" : "w-0 h-0"
              }`}
            />
            </a>
            <button
              onClick={toggleMenu}
              className="text-3xl text-white focus:outline-none"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* Full-Screen Menu */}
        {isMenuOpen && (
          <nav className="fixed top-0 left-0 w-full h-full bg-[#206760] text-white z-40 flex flex-col justify-center items-center space-y-8">
            <ul className="text-center text-2xl space-y-4">
              <li>
                <a
                  href="#about"
                  onClick={() => setIsMenuOpen(false)}
                  className="hover:text-[#f9cebd] block"
                >
                  Sobre mí
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  onClick={() => setIsMenuOpen(false)}
                  className="hover:text-[#f9cebd] block"
                >
                  Qué podemos hacer
                </a>
              </li>
              <li>
                <a
                  href="#testimonial"
                  onClick={() => setIsMenuOpen(false)}
                  className="hover:text-[#f9cebd] block"
                >
                  Historias
                </a>
              </li>
              <li>
                <a
                  href="#services-for-sale"
                  onClick={() => setIsMenuOpen(false)}
                  className="hover:text-[#f9cebd] block"
                >
                  Servicios Disponibles
                </a>
              </li>
              <li>
                <a
                  href="#tools"
                  onClick={() => setIsMenuOpen(false)}
                  className="hover:text-[#f9cebd] block"
                >
                  Herramientas
                </a>
              </li>
            </ul>
          </nav>
        )}

        {/* Fondo e Imagen del Hero */}
        <div className="absolute inset-0">
          <img
            src={hero_section.image}
            alt="Mother and baby"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#206760] opacity-40"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center text-center px-4">
          <div>
            <img
              src="/logo_alma_nino_bco.png"
              alt="Alma de niño logo"
              className="w-80 mx-auto"
            />
            <p>
              <a
                href={hero_section.cta_link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#4cb1ac] mt-8 text-white px-8 py-3 rounded-full hover:bg-[#206760] transition duration-300 inline-flex items-center gap-2"
              >
                <FaWhatsapp className="text-xl" />
                Agendar Consulta
              </a>
            </p>
            <p>
              <a
                href="#services-for-sale"
                className="bg-white text-[#206760] px-8 py-3 mt-8 rounded-full hover:bg-[#f9cebd] hover:text-[#206760] transition duration-300 inline-flex items-center gap-2"
              >
                Ver Planes de Sesión
              </a>
            </p>
          </div>
        </div>
      </div>




      {/* About Section */}
      <div id="about" className="py-20 px-4 md:px-8 bg-[#f9cebd]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-[#206760] mb-6 text-center">{about.title}</h2>
          <div className="flex flex-col md:flex-row items-center gap-8">
            <img
              src={about.image}
              alt={about.alt}
              className="w-64 h-64 rounded-full object-cover"
            />
            <div>
              <p className="text-[#206760] leading-relaxed">
                {about.text}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div id="services" className="py-20 px-4 md:px-8 bg-white">
        <h2 className="text-3xl font-bold text-[#206760] mb-12 text-center">{services.title}</h2>
        <h3 className="text-center max-w-7xl mx-auto px-4 md:px-8 mb-2 text-[#206760]">{services.subtitle}</h3>
        <br/>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.list.map((service, index) => (
            <div key={index} className="bg-[#f9cebd] p-6 rounded-lg shadow-lg text-center hover:transform hover:scale-105 transition duration-300">
              <div className="text-4xl text-[#206760] mb-4 flex justify-center">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2 text-[#206760]">{service.title}</h3>
              <p className="text-[#206760]">{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <div id="testimonial" className="py-20 px-4 md:px-8 bg-[#4cb1ac]">
        <h2 className="text-3xl font-bold text-white mb-12 text-center">{testimonials.title}</h2>
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white p-8 rounded-lg shadow-lg">
            <div className="flex flex-col items-center">
              <img
                src={testimonials.list[currentTestimonial].image}
                alt={testimonials.list[currentTestimonial].name}
                className="w-20 h-20 rounded-full mb-4 object-cover"
              />
              <p className="text-[#206760] italic text-center mb-4">"{testimonials.list[currentTestimonial].text}"</p>
              <p className="font-semibold text-[#206760]">{testimonials.list[currentTestimonial].name}</p>
            </div>
            <div className="flex justify-center mt-6 gap-4">
              {testimonials.list.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full ${currentTestimonial === index ? "bg-[#206760]" : "bg-[#f9cebd]"}`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Services for Sale Section */}
      <div id="services-for-sale" className="py-20 px-4 md:px-8 bg-[#f9cebd]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-extrabold text-[#206760] mb-12 text-center">Elige tu Plan</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className="bg-white border-2 border-[#4cb1ac] p-8 rounded-xl shadow-xl hover:shadow-2xl transition transform hover:scale-105"
              >
                <h3 className="text-2xl font-bold text-[#206760] mb-4">{plan.title}</h3>
                <p className="italic text-[#4cb1ac] mb-6">
                  "{plan.quote}" <span className="text-gray-600">- {plan.author}</span>
                </p>
                <div className="mb-6 space-y-4">
                  {plan.details.map((detail, index) => (
                    <div key={index} className="flex items-center gap-4">
                      <div className="text-2xl text-[#4cb1ac]">{detail.icon}</div>
                      <p className="text-sm text-gray-600">
                        <strong>{detail.label}:</strong> {detail.value}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="mt-6">
                  <p className="text-3xl font-extrabold text-[#206760]">
                    ${plan.price} <span className="text-sm text-gray-600">{plan.priceDescription}</span>
                  </p>
                </div>
                <button
                  onClick={() => window.location.href = plan.ctaLink}
                  className="mt-6 bg-[#206760] text-white py-3 px-6 rounded-lg text-lg font-medium hover:bg-[#4cb1ac] transition duration-300 w-full"
                >
                  {plan.ctaText}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      

      {/* Tools Section */}
      <div id="tools" className="mt-8 py-20 px-8 bg-[#f9cebd] text-[#206760]">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold text-center mb-8">Herramientas que utilizaremos</h3>
          <ul className="space-y-6">
            {tools.map((tool, index) => (
              <li key={index} className="flex items-center gap-4">
                <div className="text-3xl text-[#206760]">{tool.icon}</div>
                <p className="text-lg "><em>{tool.description}</em></p>
              </li>
            ))}
          </ul>
        </div>
      </div>



      {/* Footer Section */}
      <footer className="bg-[#206760] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <img
                src="/ico_alma_nino_color.png"
                alt="Melina González Paulos"
                className="w-24 md:w-16"
              />
              <div className="text-xl font-bold mb-4">
                {settings.site_title} 
                <span className="text-sm font-normal block">
                  {settings.tmi_phrase}
                </span>
              </div>
              
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Links</h3>
              <ul className="space-y-2">
                <li><a href="#about" className="hover:text-[#4cb1ac]">Sobre mí</a></li>
                <li><a href="#services" className="hover:text-[#4cb1ac]">Qué podemos hacer</a></li>
                <li><a href="#testimonial" className="hover:text-[#4cb1ac]">Historias</a></li>
                <li><a href="#services-for-sale" className="hover:text-[#4cb1ac]">Servicios Disponibles</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Info de Contacto</h3>
              <ul className="space-y-2">
                <li>Teléfono: <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`} target="_blank" rel="noopener noreferrer">{footer.phone}</a></li>
                <li>Email: {footer.email}</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Follow Me</h3>
              <div className="flex space-x-4">
                {footer.social.map((social, index) => (
                  <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="border-t border-[#4cb1ac] mt-8 pt-8 text-center">
            <p>&copy; {new Date().getFullYear()} Terapia Materno Infantil. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MaternalTherapyLanding;